import { Component, OnInit } from '@angular/core';
import { ApplicationBase } from 'src/app/base/application-base';
import { IWindowContent } from 'src/app/interfaces/os/window-content.interface';
import { VfmService } from 'src/app/services/io/vfm.service';
import { WindowsManagerService } from 'src/app/services/os/windows-manager.service';
import { ThemeService } from 'src/app/services/ux/theme.service';
import { JsLoader } from '../../viewer/classes/js-loader';

@Component({
  selector: 'app-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent extends ApplicationBase implements IWindowContent, OnInit {
  private scriptsLoaded = 0;
  private scripts = [
    "https://cdnjs.cloudflare.com/ajax/libs/xterm/3.14.5/xterm.min.css",
    "https://cdnjs.cloudflare.com/ajax/libs/xterm/3.14.5/xterm.min.js"
  ];

  private terminal: any;

  windowId: number;

  constructor(
    private windowsSv: WindowsManagerService,
    private vfm: VfmService,
    public theme: ThemeService
  ) {
    super();
  }

  ngOnInit(): void {
  }

  get isLoading() {
    return this.scriptsLoaded < this.scripts.length;
  }

  get loadProgress() {
    return Math.round(this.scriptsLoaded * 100 / this.scripts.length);
  }

  start(data: any, windowId: number) {
    this.windowId = windowId;

    this.windowsSv.setTitle(windowId, "Terminal");

    if (this.windowsSv.getScreenSize().width > 1024) {
      this.windowsSv.resizeWindow(windowId, 1024, 400);
    }

    this.windowsSv.centerWindow(windowId);

    this.load();
  }

  private async load() {
    const promises = JsLoader.loadAll(this.scripts);

    for (const promise of promises) {
      await promise;
      ++this.scriptsLoaded;
    }

    this.initXterm();
  }

  private initXterm() {
    this.terminal = new ((window as any).Terminal)();
    this.terminal.open(document.getElementById(`terminal-${this.windowId}`));
    this.terminal.write('Hello from \x1B[1;3;31mxterm.js\x1B[0m $ ');
  }
}
